module.exports = __webpack_public_path__ + "img/p2-29.53360f50.png";